<script lang="ts">
    import { createEventDispatcher, onDestroy, onMount, tick } from 'svelte'
    const dispatch = createEventDispatcher()
    export let small: boolean = false

    function getPermission() {
        window.api.utils.utils.requestPushNotificationPermission()
    }

    let handlerChecGranted = null
    let lastPermission = null
    async function checkGranted() {
        if (lastPermission !== Notification.permission) {
            dispatch('permission', Notification.permission)
            lastPermission = Notification.permission
        }
        if (Notification.permission === 'granted') {
            // solicita novamente pois pode ter mudado, ou ainda pode ser outro usuário.
            window.log('NotifComponent: notification (re)granted. Calling Utils.requestPushNotificationPermission()...')
            await window.api.utils.utils.requestPushNotificationPermission()
            window.log('NotifComponent: Utils.requestPushNotificationPermission() called.')
            return
        }
        if (handlerChecGranted) clearTimeout(handlerChecGranted)
        setTimeout(checkGranted, 1000)
    }

    function cancelCheckGranted() {
        if (handlerChecGranted) clearTimeout(handlerChecGranted)
    }

    let loaded = false
    onMount(async () => {
        await checkGranted()
        loaded = true
    })
    onDestroy(() => cancelCheckGranted())
</script>

{#if loaded}
    <button on:click={getPermission} class="btn btn-secondary" class:btn-sm={small}>Ativar notificações</button>
{/if}
